import type { PersonInvolvementKind } from "../types/involvement.js";

// A total `Record`, so admitting a kind without deciding whether it is
// startable does not compile.
const startableByKind: Record<PersonInvolvementKind, boolean> = {
  created_by: false,
  duty_of_care: true,
  placement: true,
  responsible_user: false,
  designated_assessor: true,
  assessor: true,
  viewer: true,
  approver: true,
  // Started only by sharing assessments, which names them in the same act.
  shared_assessment_reader: false,
};

/**
 * Whether an involvement of this kind is started through a
 * `StartInvolvementsRequest`, beside any other holders. A `created_by` involvement is written when the person's record is created,
 * and the responsible user is allocated or replaced rather than started beside
 * somebody else.
 */
export const isInvolvementKindStartable = (
  kind: PersonInvolvementKind,
): boolean => startableByKind[kind];
